module.exports = __webpack_public_path__ + "img/pricing-shape-2.812228d3.png";